import { render, staticRenderFns } from "./separator.vue?vue&type=template&id=7aa820cf&scoped=true"
import script from "./separator.vue?vue&type=script&lang=js"
export * from "./separator.vue?vue&type=script&lang=js"
import style0 from "./separator.vue?vue&type=style&index=0&id=7aa820cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa820cf",
  null
  
)

export default component.exports